import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import IButton from '../../models/button/IButton';
import { ButtonStyleType } from '../../constants/button-style-type';
import { extractCloudinaryImage } from '../../utils/mapping-helpers/cloudinary.helper';
import colorStyle from '../../styles/utils/variables.module.scss';
import { replaceAttrSpaceWithHyphen } from '../../utils/string-helpers/replace-attr-space-with-hyphen';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';
import ICtaHero from '../../models/cta-hero/ICtaHero';

export default class CtaHeroComponentModel extends BaseComponentModel {
  ctaHero: ICtaHero;
  appSettings: ApplicationSettings;
  excludedEntitiesHelper = new ExcludedEntitiesHelper();
  component = 'CtaHero';

  constructor(data: any, appSettings: ApplicationSettings) {
    super('ctaHero', appSettings);
    this.appSettings = appSettings;

    const shouldReturnEntity = this.shouldReturnEntity(data);
    if (!shouldReturnEntity.shouldReturn) {
      this.exclusionReasons.push(...shouldReturnEntity.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    this.ctaHero = this.createCtaHero(data);
  }

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    return this.excludedEntitiesHelper.shouldComponentBeReturned(this.component, entry, [], []);
  }

  private createCtaHero(data?: any): ICtaHero {
    const { anchorId, layout, imageLG, imageSM, title, copyText, button: buttonFields } = data;
    return {
      id: anchorId || data?.sys?.id || null,
      layout,
      imageDesktop: extractCloudinaryImage(imageLG?.fields?.image, imageLG?.fields?.altText),
      imageMobile: extractCloudinaryImage(imageSM?.fields?.image, imageSM?.fields?.altText),
      title,
      copyText,
      button: this.createButton(buttonFields?.fields),
    };
  }

  private createButton(buttonFields?: any): IButton | undefined {
    if (!buttonFields) return undefined;

    const isOutline = buttonFields.buttonStyle === ButtonStyleType.Outline;
    const primaryColor = this.appSettings.branding.primaryColor;

    return {
      buttonID: buttonFields.id || replaceAttrSpaceWithHyphen(buttonFields.buttonName),
      buttonURL: buttonFields.url,
      buttonAriaLabel: buttonFields.buttonName,
      buttonNewTab: buttonFields.target,
      copyColor: isOutline ? primaryColor : colorStyle.white,
      backgroundColor: isOutline ? colorStyle.white : primaryColor,
      outlineColor: primaryColor,
      hoverBackgroundColor: this.appSettings.branding.primaryHoverColor,
      activeBackgroundColor: this.appSettings.branding.primaryActiveColor,
      children: buttonFields.text,
      buttonSize: buttonFields.buttonSize,
      buttonStyle: buttonFields.buttonStyle,
      buttonType: 'button',
      heapIdentifier: buttonFields.id || replaceAttrSpaceWithHyphen(buttonFields.buttonName),
    };
  }
}
